import { userActions } from '../../redux/actions/userAction';
import { connect } from 'react-redux';
import queryString from 'query-string';
import handleRsponse from '../../helper/handleRsponse';
import { Form, Skeleton, Button, Row, Col, Card, ConfigProvider } from 'antd';
import React, { useEffect, useState } from 'react';
import happyCallRepo from '../../repository/happyCallRepo';
const { Meta } = Card;

const HappyCallProductList = (props) => {
    const [isLoaded, setIsLoaded] = useState(true);
    const [productList, setProductList] = useState([
        // { id: 1, productName: 'ظرفشویی', serviceNo: '12455' },
        // { id: 2, productName: 'لباسشویی', serviceNo: '87777' },
        // { id: 3, productName: 'یخچال', serviceNo: '33211' }
        {}, {}, {}, {}, {}, {}
    ]);
    useEffect(() => {
        let customerCode = queryString.parse(props.location.search).customerCode;
        /*to do:call api for get customer product list*/
       // alert(customerCode);
        if (customerCode !== undefined)
            handleRsponse.handleAxios(happyCallRepo.getProductList(`customerCode=${customerCode}`), fillProductList, setIsLoaded);
    }, []);
    const fillProductList = (response) => {
        setProductList(handleRsponse.getResponse(response));
    }
    const goToRegisterHappyCall = (item) => {
        console.log(item, 'item');
        props.history.push('/registerHappyCall', item);
    }
    const productCards = (productList != null) ? productList.map((item, i) => {
        return (
            <Col xs={20} xl={8} lg={8} md={8}>
                <div key={item.id} onClick={() => { if (isLoaded) goToRegisterHappyCall(item) }}>
                    <Card hoverable >
                        <Skeleton
                            show={!isLoaded}
                            loading={!isLoaded}
                            active
                            paragraph={{
                                rows: 1,
                            }}
                            size='small'
                        >
                            <Meta title={item.productName} description={item.serviceNo} />
                        </Skeleton>
                    </Card>
                </div>
            </Col>
        )
    }) : '';
    return (

        <ConfigProvider direction="rtl">
            <div className="site-card-wrapper">
                <center><p>محصولات نظرسنجی</p></center>
                <br />
                <Row gutter={16} className="noMargin">
                    {productCards}
                </Row>
            </div>
        </ConfigProvider>

    )
}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    cc: state.user.currentCustomerInfo,
    serviceTypeId: state.user.currentServiceTypeId,
    currentMobile: state.user.currentMobile,
    currentUser: state.user.currentUser
});
const mapActionCreateor = {
    //setCustomer: userActions.updateCurrentCustomer,
    updateCurrentUser: userActions.setCurrentUser,
}
export default connect(mapStateToProps, mapActionCreateor)(HappyCallProductList)